<template>
  <div>
    <NavBar />
    <b-modal id="modal_set_status" title="Alterar permissão" hide-footer>
      <v-alert class="v-warning">
        {{ change_action_message }}
      </v-alert>
      <div class="text-right">
        <v-btn
          class="v-primary"
          @click="
            getPermissions();
            $bvModal.hide('modal_set_status');
          "
        >
          <span class="fa fa-arrow-left"></span>
          Voltar
        </v-btn>
        <v-btn
          type="submit"
          class="v-success ml-2"
          @click="setStatusCallback()"
        >
          <span class="fa fa-check"></span>
          Confirmar
        </v-btn>
      </div>
    </b-modal>
    <div class="container-fluid">
      <v-card>
        <v-card-title>
          <div class="col">Permissões</div>
          <div class="col-3">
            <v-select
              label="Perfil"
              v-model="profile_id"
              :loading="profiles_loading"
              :items="profiles_items"
              hide-details
              @change="getPermissions()"
            >
            </v-select>
          </div>
          <div class="col-5">
            <v-text-field
              v-model="permissions_search"
              append-icon="mdi-magnify"
              label="Pesquisar"
              single-line
              hide-details
            />
          </div>
        </v-card-title>
        <v-card-text>
          <div class="col">
            <ErrorsMessages :errors="errors" />
            <v-data-table
              dense
              :headers="permissions_headers"
              :items="permissions_items"
              :search="permissions_search"
              :footer-props="{
                'items-per-page-options': [100],
                'items-per-page-text': 'Mostrar',
              }"
              :loading="permissions_loading"
              group-by="group_name"
            >
              <template
                v-slot:[`group.header`]="{ group, headers, toggle, isOpen }"
              >
                <td :colspan="headers.length" @click="toggle">
                  <v-btn x-small icon :ref="group">
                    <v-icon v-if="isOpen">mdi-plus</v-icon>
                    <v-icon v-else>mdi-minus</v-icon>
                  </v-btn>
                  <span class="mx-2">{{ group.toUpperCase() }}</span>
                </td>
              </template>
              <template v-slot:[`item.name`]="{ item }">
                {{ item.name.toUpperCase() }}
              </template>
              <template v-slot:[`item.write`]="{ item }">
                <v-switch
                  class="m-0 p-0"
                  v-if="item.actions.write"
                  dense
                  color="success"
                  v-model="item.write"
                  @change="(v) => switchChange(item, 'write', v)"
                ></v-switch>
              </template>
              <template v-slot:[`item.edit`]="{ item }">
                <v-switch
                  class="m-0 p-0"
                  v-if="item.actions.edit"
                  dense
                  color="warning"
                  v-model="item.edit"
                  @change="(v) => switchChange(item, 'edit', v)"
                >
                </v-switch>
              </template>
              <template v-slot:[`item.read`]="{ item }">
                <v-switch
                  class="m-0 p-0"
                  v-if="item.actions.read"
                  dense
                  color="primary"
                  v-model="item.read"
                  @change="(v) => switchChange(item, 'read', v)"
                ></v-switch>
              </template>
              <template v-slot:[`item.remove`]="{ item }">
                <v-switch
                  class="m-0 p-0"
                  v-if="item.actions.remove"
                  dense
                  color="red"
                  v-model="item.remove"
                  @change="(v) => switchChange(item, 'remove', v)"
                ></v-switch>
              </template>
            </v-data-table>
          </div>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";

import ErrorsMessages from "../templates/components/ErrorsMessages";

import api from "../services/api";

import toast from "../components/ToastNotification";

export default {
  name: "PermissionsAlt",

  components: {
    NavBar,
    ErrorsMessages,
  },

  data() {
    return {
      errors: [],

      profile_id: "",
      profile_name: "",
      profiles_items: [],
      profiles_loading: false,

      permissions_search: "",

      permissions_headers: [
        { text: "Nome", value: "name", sortable: false },
        { text: "Categoria", value: "group_name" },
        { text: "Criar", value: "write", sortable: false },
        { text: "Modificar", value: "edit", sortable: false },
        { text: "Visualizar", value: "read", sortable: false },
        { text: "Remover", value: "remove", sortable: false },
      ],

      permissions_items: [],

      permissions_loading: false,

      change_action_message: "",

      setStatusCallback: function () {},
    };
  },

  created() {
    this.getProfiles();
  },

  methods: {
    async getProfiles() {
      try {
        this.profiles_loading = true;

        let response = await api.get("/admin/profiles");
        let { error, errors, profiles } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          for (let profile of profiles) {
            this.profiles_items.push({ value: profile.id, text: profile.name });
          }
          if (this.profiles_items.length > 0) {
            this.profile_id = this.profiles_items[0].value;
            this.profile_name = this.profiles_items[0].text;
            this.getPermissions();
          }
          this.errors = [];
        }

        this.profiles_loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getPermissions() {
      try {
        this.permissions_loading = true;

        for (let profile of this.profiles_items) {
          if (profile.value == this.profile_id) {
            this.profile_name = profile.text;
            break;
          }
        }

        let { profile_id } = this;
        let params = { profile_id };

        let response = await api.get("/admin/permissions/by-profile", {
          params,
        });

        let { error, errors, permissions } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.permissions_items = permissions;
          this.errors = [];
        }

        this.permissions_loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async switchChange(permission, action, value) {
      let act = {
        write: "criação",
        edit: "modificação",
        read: "visualização",
        remove: "remoção",
      }[action];

      this.change_action_message = `${
        value ? "Permitir" : "Bloquear"
      } ${act} de ${permission.name.toLowerCase()} por ${this.profile_name.toLowerCase()}`;

      this.setStatusCallback = function () {
        this.setStatus(permission.id, action, value);
        this.$bvModal.hide("modal_set_status");
      };

      this.$bvModal.show("modal_set_status");
    },

    async setStatus(permission_id, action, value) {
      try {
        this.permissions_loading = true;

        let { profile_id } = this;
        let params = { profile_id, permission_id, action, value };
        let response = await api.patch("/admin/permission/set", params);
        let { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.getPermissions();
        }

        this.permissions_loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>